import { useNonPersistantMainStore } from "controller";
import { UnautherizedScreen } from "pages/error-screens/UnautherizedScreen";
import { ReactNode } from "react";

/**
 * Gates its children behind a feature flag from the feature-flags API
 * (e.g. "public_api"). Renders `fallback` (default: UnautherizedScreen)
 * when the flag is absent or disabled.
 */
export const FeatureFlagWrapper = ({
  flag,
  children,
  fallback,
}: {
  flag: string;
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const featureFlags = useNonPersistantMainStore((state) => state.featureFlags);
  const isEnabled = Boolean(featureFlags?.[flag]);

  return <>{isEnabled ? children : (fallback ?? <UnautherizedScreen />)}</>;
};
